// Components
import { useState } from 'react';
import Card from '../../SharedComponets/Card';
import { RootState } from '../../store';
import { useReduxSelector } from '../../Store/reduxHooks';
import EventQuestions from './EventQuestions';

import { Helmet } from 'react-helmet';

const Questions = (props) => {
  const [subTitle, setSubTitle] = useState<string>('');
  const [title, setTitle] = useState<string>('Questions');
  const clientName = useReduxSelector(
    (state: RootState) => state.ClientInfo.client_name
  );

  return (
    <Card className="w-100 d-flex">
      <Helmet>
        <title>
          {`${clientName} - ${title} ${subTitle ? `- ${subTitle}` : ''}`}
        </title>
      </Helmet>

      <EventQuestions
        setTitle={setTitle}
        setSubTitle={setSubTitle}
        {...props}
      />
    </Card>
  );
};

export default Questions;
